export type WeightedItem = {
  mediaId: string;
  weight: number;
};

export function weightedPick<T extends WeightedItem>(
  items: T[],
  excludeMediaIds: string[] = [],
): T | null {
  if (!items.length) return null;

  const excludeSet = new Set(excludeMediaIds);
  const eligible = items.filter((item) => item.weight > 0 && !excludeSet.has(item.mediaId));

  if (!eligible.length) return null;

  const totalWeight = eligible.reduce((sum, item) => sum + item.weight, 0);
  if (totalWeight <= 0) return null;

  let roll = Math.random() * totalWeight;
  for (const item of eligible) {
    roll -= item.weight;
    if (roll <= 0) return item;
  }

  return eligible[eligible.length - 1] ?? null;
}
